import useLocationSmart from './use-ls';
import './lsdp'; // device profiling toolkit

const LocationSmart = () => {
	/**
	 * Hook with encapsulated implementation
	 */
	useLocationSmart();
	return null;
};

export default LocationSmart;
export { eventStream, EVENTS, States } from './config';
